import {
  destroyAdmin,
  getAdmin,
  patchAdmin,
  postAdmin,
  putAdmin,
} from "../axios/api/AdminBaseUrl";
import { buildQueryString } from "../utils/queryParams";

export const violation = {
  list: {
    key: "list",
    call: (
      page,
      search,
      company_name,
      property_name,
      date_start,
      date_end,
      status,
      building,
      pending,
      ordering,
    ) => {
      const query = buildQueryString({
        page,
        search,
        company: company_name,
        property_id: property_name,
        captured_at_from: date_start,
        captured_at_to: date_end,
        offense: status,
        building,
        pending,
        ordering,
      });
      return getAdmin(`/admin/violations/?${query}`);
    },
  },
  add: {
    key: "add",
    call: (payload) => {
      return postAdmin(`/admin/violations/`, payload);
    },
  },
  details: {
    key: "details",
    call: (id) => {
      return getAdmin(`/admin/violations/${id}/`);
    },
  },
  log: {
    key: "log",
    call: (page, id) => {
      const query = buildQueryString({ page });
      return getAdmin(`/admin/violation-logs/${id}/?${query}`);
    },
  },
  delete: {
    key: "delete",
    call: (id, permanent = false) => {
      const query = permanent ? "?permanent=true" : "";
      return destroyAdmin(`/admin/violations/${id}/${query}`);
    },
  },
  update: {
    key: "update",
    call: (Id, payload) => {
      return putAdmin(`/admin/violations/${Id}/`, payload);
    },
  },
  company: {
    key: "company",
    call: (page, search) => {
      const query = buildQueryString({ page, search, page_size: 100 });
      return getAdmin(`/admin/company_dropdown/?${query}`);
    },
  },
  property: {
    key: "property",
    call: (companyId, page, search) => {
      const query = buildQueryString({
        company_id: companyId,
        page,
        search,
        page_size: 100,
      });
      return getAdmin(`/admin/property_dropdown_by_company/?${query}`);
    },
  },
  block: {
    key: "block",
    call: (propertyId, page, search) => {
      const query = buildQueryString({ page, search, page_size: 100 });
      return getAdmin(`/admin/building_dropdown/${propertyId}?${query}`);
    },
  },
  resident: {
    key: "resident",
    call: (blockId, page, search) => {
      const query = buildQueryString({ page, search, page_size: 100 });
      return getAdmin(`/admin/unit_dropdown/${blockId}?${query}`);
    },
  },
captured: {
    key: "captured",
    call: (page, search, propertyId) => {
      const query = buildQueryString({
        page,
        search,
        property_id: propertyId,
        page_size: 100,
      });
      return getAdmin(`/admin/property_managers_dropdown/?${query}`);
    },
  },
 filtetproperty: {
    key: "filtetproperty",
    call: (page, search) => {
      const query = buildQueryString({ page, search, page_size: 100 });
      return getAdmin(`/admin/property/?${query}`);
    },
  },
  offenseadd: {
    key: "offenseadd",
    call: (id, payload) => {
      return patchAdmin(`/admin/mark-violation-offense/${id}/`, payload);
    },
  },
  download: {
    key: "download",
    call: (id, type) => {
      const query = buildQueryString({ type });
      return getAdmin(`/admin/violation_pdf_report/${id}/?${query}`);
    },
  },
  report: {
    key: "report",
    call: (
      search,
      company_name,
      property_name,
      date_start,
      date_end,
      status,
    ) => {
      const query = buildQueryString({
        search,
        company: company_name,
        property: property_name,
        captured_at_from: date_start,
        captured_at_to: date_end,
        offense: status,
      });
      return getAdmin(`/admin/violation_report/?${query}`);
    },
  },
};
